import { createAsyncThunk } from '@reduxjs/toolkit';
import { getParams } from '../common/get-params';
let drilldownControllerRef = null;

const getPerformanceDrilldown = async (
  { timeFrame = {}, group = {}, filters = {}, drilldown = {} },
  { extra: { atsHttp } }
) => {
  if (drilldownControllerRef) {
    drilldownControllerRef.abort();
  }

  const controller = new AbortController();
  drilldownControllerRef = controller;
  try {
    const params = getParams({
      timeFrame,
      group,
      filters,
      drilldown,
      compare: false,
    });
    const response = await atsHttp.post(
      `/reports/recruiter_performance/drilldown`,
      params,
      {
        signal: controller.signal,
      }
    );
    return response;
  } catch (error) {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      throw error;
    }
    throw error;
  }
};

export const fetchPerformanceDrilldown = createAsyncThunk(
  'ats-reports/recruiter_performance/drilldown',
  getPerformanceDrilldown
);
